import React from 'react';
import { Link } from 'react-router-dom';
import mtbLogoGif from '../images/mtb_logo.gif';

const BottomBar = () => {
  return (
    <div className="bottom-bar">
      <Link className="bottom-bar-home-link" to="/" aria-label="Back to home">
        <img
          src={mtbLogoGif}
          alt=""
          className="bottom-bar-logo"
        />
        <div className="home-label">HOME</div>
      </Link>
    </div>
  );
};

export default BottomBar;
